import * as yup from 'yup'
export const operationSchema = yup.object().shape({
  name: yup.string().required('nameRequired'),
  colorCode: yup.string().optional().nullable().default(''),
  description: yup.string().optional().nullable()
})
